/* eslint-disable */
export default {
  region: '地區',
  calling: '通話',
  logout: '登出',
  version: '版本',
  settings: '設定',
  selectToDialSMS: '選取以撥號/傳送簡訊',
  selectToDial: '選取以撥號',
  selectToSMS: '選取以傳送簡訊',
  clickToDial: '點擊撥號',
  autoCreateLog: '自動建立通話記錄',
  autoCreateSMSLog: '自動建立簡訊記錄',
  autoLogCalls: '自動記錄通話',
  autoLogNotes: '自動記錄筆記',
  autoLogSMS: '自動記錄簡訊',
  clickToSMS: '點擊傳送簡訊',
  logSMSContent: '記錄簡訊內容',
  clickToDialSMS: '點擊撥號/傳送簡訊',
  logExtensionCall: '記錄分機通話',
  audio: '音訊',
  language: '語言',
  feedback: '意見回饋',
  userGuide: '新功能',
  quickAccess: '快速存取設定',
  report: '分析報告',
  shareIdea: '分享意見',
  openEntityFrom: 'Salesforce 物件行為',
  ctiPanelSize: 'CTI 面板大小',
  openInNewTab: '在新索引標籤中開啟',
  openInCurrentTab: '在目前索引標籤中開啟',
  reportIssue: '回報問題',
  contactSupport: '聯絡支援部門',
  selectToDialHint:
    '為了獲得更佳的體驗，請在大量電話號碼頁面中選取要使用 RingCentral 撥打的電話號碼。',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
